import { useRef } from 'react'

import { useFlags } from 'shared/components/common/feature_flags/useFlags'
import useIsClient from 'shared/js/hooks/useIsClient'

import CartStorage from './CartStorage'
import { getIsCustomDomain } from './attributionUtils'

/**
 * Custom hook that provides a CartStorage instance.
 * Creates and maintains a single CartStorage instance per component mount.
 * The instance is initialized based on feature flags and domain configuration.
 *
 * @returns CartStorage instance or null if not ready to be initialized
 */
export function useCartStorage(): CartStorage | null {
  const { ooCookieStorageCartGuid } = useFlags()
  const isClient = useIsClient()
  const storageRef = useRef<CartStorage | null>(null)

  const cartStorageReady =
    typeof ooCookieStorageCartGuid !== 'undefined' && isClient

  // Initialize CartStorage instance on first render when ready
  if (cartStorageReady && !storageRef.current) {
    storageRef.current = new CartStorage({
      isCustomDomain: getIsCustomDomain(window.location.hostname),
      cookieStorageEnabled: ooCookieStorageCartGuid
    })
  }

  return storageRef.current
}
